export default __webpack_public_path__ + "static/media/plus_tmp.f3b4f127.svg";